<div class="container-fluid mb-5 mt-3 px-2 px-md-3 px-lg-5">
  <span class="d-flex align-items-center today-date-text mb-1">
    Today: {{ today | date : "dd/MM/yyyy" }}
  </span>

  <div class="business-details">
    <div class="card py-1 px-1">
      <div class="card-body">
        <p class="card-title">Welcome {{ bizName }}</p>

        <div class="biz-data-row m-0 p-0">
          <span class="label">Company ID</span>
          <span class="divider-icon">: </span>
          <span class="value">{{ bizAccountNumber }}</span>
        </div>
        <div class="biz-data-row m-0 p-0">
          <span class="label">User Name</span>
          <span class="divider-icon"> : </span>
          <span class="value">{{ userName }}</span>
        </div>
        <div class="biz-data-row m-0 p-0">
          <span class="label">Last login Date</span>
          <span class="divider-icon"> : </span>
          <span class="value">{{ lastLoginDate | date:'dd/MM/yyyy hh:mm a' }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
